type ExpiredScreenProps = {
  onBackToOffers: () => void;
};

export function ExpiredScreen({ onBackToOffers }: ExpiredScreenProps) {
  return (
    <main className="offer-result-page" aria-label="Оффер истёк">
      <section className="offer-result-card panel-card">
        <div className="offer-result-icon is-expired" aria-hidden="true">⌛</div>
        <span className="offers-eyebrow">Время вышло</span>
        <h1>Оффер истёк</h1>
        <p>Вы не успели воспользоваться. Возможно, заведение запустит новый.</p>
        <button className="primary-button" type="button" onClick={onBackToOffers}>
          В Предложения
        </button>
      </section>
    </main>
  );
}
